import React, { useState } from 'react';
import LocationSearch from '../components/LocationSearch';

const LocationSearchDemo = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchStats, setSearchStats] = useState({ time: 0, count: 0 });

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    console.log('Selected location:', location);
  };

  return (
    <div style={{ 
      maxWidth: '800px', 
      margin: '50px auto', 
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <h1 style={{ 
        fontSize: '32px', 
        fontWeight: '700', 
        marginBottom: '10px',
        color: '#333'
      }}>
        India Location Search
      </h1>
      <p style={{ 
        fontSize: '16px', 
        color: '#666', 
        marginBottom: '10px' 
      }}>
        Search across 650,000+ villages, talukas, and districts in India
      </p>

      {/* Performance Badge */}
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: '#e8f5e9',
        border: '1px solid #4caf50',
        borderRadius: '20px',
        marginBottom: '20px',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2e7d32'
      }}>
        <span>⚡</span>
        <span>FULLTEXT Search Enabled</span>
      </div>

      <LocationSearch 
        onSelect={handleLocationSelect}
        placeholder="Type to search for a village, taluka, or district..."
      />

      {/* Performance Metrics */}
      {selectedLocation && selectedLocation.searchTime !== undefined && (
        <div style={{
          marginTop: '15px',
          padding: '12px 16px',
          backgroundColor: '#fff3e0',
          border: '1px solid #ff9800',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          fontSize: '13px',
          fontWeight: '500'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#e65100' }}>
            <span>⚡</span>
            <span>Search Time: {selectedLocation.searchTime}ms</span>
          </div>
          <div style={{ 
            height: '20px', 
            width: '1px', 
            backgroundColor: '#ffb74d' 
          }} />
          <div style={{ color: '#e65100' }}>
            {selectedLocation.searchTime < 50 ? '🚀 Excellent' : 
             selectedLocation.searchTime < 100 ? '✅ Good' : 
             selectedLocation.searchTime < 200 ? '⚠️ Fair' : '🐌 Slow'}
          </div>
        </div>
      )}

      {selectedLocation && (
        <div style={{
          marginTop: '20px',
          padding: '20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: '600', 
            marginBottom: '15px',
            color: '#333'
          }}>
            Selected Location Details
          </h2>
          <div style={{ display: 'grid', gap: '12px' }}>
            <DetailRow label="Village/Town" value={selectedLocation.name} />
            <DetailRow label="Taluka" value={selectedLocation.taluka_name} />
            <DetailRow label="District" value={selectedLocation.district_name} />
            <DetailRow label="State" value={selectedLocation.state_name} />
            {selectedLocation.code && <DetailRow label="Code" value={selectedLocation.code} />}
            {selectedLocation.latitude && selectedLocation.longitude && (
              <>
                <DetailRow label="Latitude" value={selectedLocation.latitude} />
                <DetailRow label="Longitude" value={selectedLocation.longitude} />
              </>
            )}
          </div>

          {selectedLocation.latitude && selectedLocation.longitude && (
            <a
              href={`https://www.google.com/maps?q=${selectedLocation.latitude},${selectedLocation.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: '15px',
                padding: '10px 20px',
                backgroundColor: '#4a90e2',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#357abd'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#4a90e2'}
            >
              📍 View on Google Maps
            </a>
          )}
        </div>
      )}

      {/* Feature List */}
      <div style={{
        marginTop: '30px',
        padding: '20px',
        backgroundColor: '#fff',
        border: '1px solid #e9ecef',
        borderRadius: '8px'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          marginBottom: '15px',
          color: '#333'
        }}>
          ✨ Features Implemented
        </h3>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'grid',
          gap: '10px'
        }}>
          <FeatureItem text="FULLTEXT search on 650k+ records" />
          <FeatureItem text="Request cancellation (prevents stale results)" />
          <FeatureItem text="CSS modules (optimized re-renders)" />
          <FeatureItem text="Real-time performance metrics" />
          <FeatureItem text="Keyboard navigation (↑↓ arrows, Enter)" />
          <FeatureItem text="300ms debounce for smooth typing" />
        </ul>
      </div>
    </div>
  );
};

const DetailRow = ({ label, value }) => (
  <div style={{ display: 'flex', gap: '10px' }}>
    <span style={{ 
      fontWeight: '600', 
      color: '#555',
      minWidth: '120px',
      fontSize: '14px'
    }}>
      {label}:
    </span>
    <span style={{ 
      color: '#333',
      fontSize: '14px'
    }}>
      {value}
    </span>
  </div>
);

const FeatureItem = ({ text }) => (
  <li style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#555'
  }}>
    <span style={{ color: '#4caf50', fontSize: '16px' }}>✓</span>
    <span>{text}</span>
  </li>
);

export default LocationSearchDemo;
